export const permissions = {
  VIEW_DASHBOARD: "VIEW_DASHBOARD",
  VIEW_TEMPLATE: "VIEW_TEMPLATE",
  ADD_TEMPLATE: "ADD_TEMPLATE",
  EDIT_TEMPLATE: "EDIT_TEMPLATE",
  VIEW_LOA: "VIEW_LOA",
  VIEW_LOO: "VIEW_LOO",
  EDIT_LOO: "EDIT_LOO",
  ADD_LOO: "VIEW_LOO",
  VIEW_CMU:"VIEW_CMU",
  ADD_LOA: "ADD_LOA",
  EDIT_LOA: "EDIT_LOA",
  APPROVE_LOA: "APPROVE_LOA",
  VIEW_CONTRACT: "VIEW_CONTRACT",
  EDIT_CONTRACT: "EDIT_CONTRACT",
  ADD_CONTRACT: "ADD_CONTRACT",
  APPROVE_CONTRACT: "APPROVE_CONTRACT"
};

export const Roles = {
  SPA_USER: "SPA_USER",
  SPA_REVIEWER: "SPA_REVIEWER",
  SPA_APPROVER:"SPA_APPROVER",
  CMU_REVIEWER: "CMU_REVIEWER",
  LOA_CREATOR: "LOA_CREATOR",
  LOA_REVIEWER: "LOA_REVIEWER",
  LOO_CREATOR: "LOO_CREATOR",
  LOO_REVIEWER: "LOO_REVIEWER",
  CONTRACT_CREATOR: "CONTRACT_CREATOR",
  CONTRACT_REVIEWER: "CONTRACT_REVIEWER",
  TA_REVIEWER: "TA_REVIEWER",
  PCD_USER: "PCD_USER",
  PCD_ADMIN: "PCD_ADMIN",
  COMMERCIAL_USER: "COMMERCIAL_USER",
  COMMERCIAL_ADMIN: "COMMERCIAL_ADMIN",
  LEGAL_USER: "LEGAL_USER",
  LEGAL_ADMIN: "LEGAL_ADMIN",
  SPA_ADMIN: "SPA_ADMIN",
};

// export const getPermissions = {
//   [Roles.COMMERCIAL_USER]: [
//
//   ],
//   [Roles.PCD_USER]: [
//
//   ],
//   [Roles.CLM_USER]: [
//
//   ],
//   [Roles.LOA_CREATOR]: [
//       permissions.VIEW_DASHBOARD,
//       permissions.VIEW_TEMPLATE,
//       permissions.ADD_TEMPLATE,
//       permissions.EDIT_TEMPLATE,
//   ],
//   [Roles.LOA_REVIEWER]: [
//       permissions.VIEW_DASHBOARD,
//       permissions.VIEW_LOA,
//       permissions.APPROVE_LOA,
//   ],
//   [Roles.CONTRACT_CREATOR]: [
//     permissions.VIEW_DASHBOARD,
//     permissions.VIEW_CONTRACT,
//     permissions.ADD_CONTRACT,
//     permissions.EDIT_CONTRACT,
//     permissions.VIEW_LOA,
//   ],
//   [Roles.CONTRACT_REVIEWER]: [
//     permissions.VIEW_DASHBOARD,
//     permissions.VIEW_CONTRACT,
//     permissions.APPROVE_CONTRACT,
//   ]
// };
